// React
import React from 'react';
// Material-UI
import { Container, Divider, Grid, useMediaQuery } from '@material-ui/core';
// Otras libs

// Componentes
import { TituloContenedor } from './TituloContenedor';
import { FiltrosContenedor } from './FiltrosContenedor';
import { AccionesContenedor } from './AccionesContenedor';
import { ContenidoContenedor } from './ContenidoContenedor';
import { HeaderContenidoContenedor } from './HeaderContenidoContenedor';
// Vistas

// Servicios

// Funciones

// Hooks
import useSize from 'hooks/useSize';

/**
 * 
 * @typedef {Object} Props
 * @property {'md' | 'lg'} maxWidth Ancho de contenedor
 */

/**
 * Sección
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns 
 */
export const Contenedor = ({ 
    maxWidth = 'md',
    children,
}) => {
    // Idioma
    
    // Token
    
    // Estados
    const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'));
    const size = useSize();
    const tCount = React.Children.toArray(children).filter(c => c.type === TituloContenedor).length;
    const usaFiltros = React.Children.toArray(children).filter(c => c.type === FiltrosContenedor).length > 0;
    // Paginador

    // Listas
    
    // Funciones
    const getSize = () => {
        switch (maxWidth) {
            case 'md': return 600;
            case 'lg': return 285;
            default: return 585;
        }
    };
    // Otros

    // Vista
    return (
        <Container maxWidth={maxWidth} justify="center" style={{ paddingBottom: 25, maxWidth: mdUp ? `${size.innerWidth-getSize()}px` : undefined }}>
            <Grid container style={{ paddingTop: tCount ? "30px" : "10px" }}>
                {!usaFiltros && (
                    <Grid item xs={12} md={12} container alignItems="center">
                        <Grid item xs={12} sm={9} md={9} style={{ marginBottom: tCount ? '15px' : '0' }}>
                            {React.Children.map(children, (child) => {
                                if (child.type === TituloContenedor) {
                                    return React.cloneElement(child);
                                }
                            })}
                        </Grid>
                        <Grid item xs={12} sm={3} md={3} container justifyContent="center">
                            {React.Children.map(children, (child) => {
                                if (child.type === AccionesContenedor) {
                                    return React.cloneElement(child);
                                }
                            })}
                        </Grid>
                    </Grid>
                )}

                {usaFiltros && (
                    <>
                        <Grid item xs={12} md={12} style={{ marginBottom: tCount ? '20px' : '0' }}>
                            {React.Children.map(children, (child) => {
                                if (child.type === TituloContenedor) {
                                    return React.cloneElement(child);
                                }
                            })}
                        </Grid>
                        <Grid item xs={12} md={12} container justifyContent="space-between">
                            <Grid item xs>
                                {React.Children.map(children, (child) => {
                                    if (child.type === FiltrosContenedor) {
                                        return React.cloneElement(child);
                                    }
                                })}
                            </Grid>
                            {React.Children.map(children, (child) => {
                                if (child.type === AccionesContenedor) {
                                    return React.cloneElement(child);
                                }
                            })}
                        </Grid>
                    </>
                )}

                <Grid item xs={12} md={12} style={{ marginTop: usaFiltros ? 20 : 5, marginBottom: usaFiltros ? 20 : 15 }}>
                    <Divider />
                </Grid>

                <Grid item xs={12} md={12}>
                    {React.Children.map(children, (child) => {
                        if (child.type === HeaderContenidoContenedor) {
                            return React.cloneElement(child);
                        }
                    })}
                    {React.Children.map(children, (child) => {
                        if (child.type === ContenidoContenedor) {
                            return React.cloneElement(child);
                        }
                    })}
                </Grid>
            </Grid>
        </Container>
    );
};
